import React, { useCallback, useState } from "react";
import { Button, Divider, Grid } from "@mui/material";
import styled from "styled-components";
import { useModal } from "./Modal";

/* ModalActions: section of a modal that contains action buttons */
const ModalActions = (props) => {
  return (
    <div>
      <Divider />
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        {props.children}
      </Grid>
    </div>
  );
};

/* ModalActionButton: MUI Button with extra functionality to close parent modal after button's onClick is called */
const ModalActionButton = (props) => {
  const { closeModal } = useModal();
  return (
    <Grid item xs={6} sm={6}>
      <ActionButton {...props} onClick={() => closeModal()}></ActionButton>
    </Grid>
  );
};

const ModalLoadingButton = (props) => {
  const { onClick, ...rest } = props;
  const { closeModal } = useModal();
  const [loading, setLoading] = useState(false);

  const onClickCallBack = useCallback((e) => {
    setLoading(true);
    return onClick(e).then((result) => {
      setLoading(false);
      if (result) closeModal();
    });
  }, []);

  return (
    <Grid item xs={6} sm={6}>
      <ActionButton {...rest} loading={loading} onClick={onClickCallBack} />
    </Grid>
  );
};

const ActionButton = styled(Button)`
  width: 90%;
  height: 50px;
  margin: 10px !important;
`;

export { ModalActions, ModalActionButton, ModalLoadingButton };
